import { bodyFixed, bodyStatic } from '../helpers/helper.js';

export default class Modal {
  constructor() {
    this.activeClass = 'is-active';
    this.autoIdPrefix = 'modal-target-';

    this.modalTrigger = document.querySelectorAll('.js-modal_trigger');
    this.modalClose = document.querySelectorAll('.js-modal_close');
    this.modalTarget = document.querySelectorAll('.js-modal_target');

    this.currentY = 0;
    this.bodyTag = document.querySelector('body');
    this.focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, [tabindex="0"], [contenteditable], iframe, .js-modal_start';
    if(this.modalTrigger.length !== 0) {
      this.init();
    }
  }

  init() {
    this.setupModalPairs();
    this.ariaSet();
    this.focusTrap();

    this.modalTrigger.forEach(el => {
      const ariaControls = el.getAttribute('aria-controls');
      const target = document.querySelector('.js-modal_target[id="' + ariaControls +'"]');
      if(target) {
        el.addEventListener('click', () => {
          el.setAttribute('aria-expanded', 'true');
          target.classList.add(this.activeClass);
          target.setAttribute('aria-hidden', 'false');

          let focusItems = [...target.querySelectorAll('[tabindex]')];
          focusItems.forEach(e => {
            e.setAttribute('tabindex', 0);
          });

          if(focusItems.length > 0) {
            focusItems[0].focus();
          }
          bodyFixed();

          const targetIframe = target.querySelector('iframe');
          if (targetIframe) {
            targetIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          }
        });
      }
    });

    this.modalClose.forEach(el => {
      el.addEventListener('click', () => {
        this.closeCnt();
      });
    });

    this.modalTarget.forEach(el => {
      el.addEventListener('click', (e) => {
        const parent = e.target.closest('.js-modal_cnt_inner');

        if(!parent) {
          this.closeCnt();
        }
      });
    });
  }

  setupModalPairs() {
    const usedIds = new Set();
    this.modalTarget.forEach(target => {
      const targetId = target.getAttribute('id');
      if(targetId) {
        usedIds.add(targetId);
      }
    });

    let serial = 1;
    const createAutoId = () => {
      let candidate = this.autoIdPrefix + serial;
      while(usedIds.has(candidate)) {
        serial += 1;
        candidate = this.autoIdPrefix + serial;
      }
      usedIds.add(candidate);
      serial += 1;
      return candidate;
    };

    const targetsWithoutId = [];
    this.modalTarget.forEach(target => {
      let targetId = target.getAttribute('id');
      if(!targetId) {
        targetId = createAutoId();
        target.setAttribute('id', targetId);
        targetsWithoutId.push(target);
      }
    });

    const triggersWithoutControls = [...this.modalTrigger].filter(trigger => {
      return !trigger.getAttribute('aria-controls');
    });

    triggersWithoutControls.forEach((trigger, index) => {
      const target = targetsWithoutId[index];
      if(!target) return;
      const targetId = target.getAttribute('id');
      if(!targetId) return;

      trigger.setAttribute('aria-controls', targetId);
    });
  }

  closeCnt() {
    const trigger = document.querySelector('.js-modal_trigger[aria-expanded="true"]');
    const target = document.querySelector('.js-modal_target[aria-hidden="false"]');
    if(!trigger || !target) return;

    trigger.setAttribute('aria-expanded', 'false');
    target.setAttribute('aria-hidden', 'true');

    const targetIframe = target.querySelector('iframe');
    target.classList.remove(this.activeClass);
    if(targetIframe) {
      targetIframe.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
      targetIframe.contentWindow.postMessage('{"event":"command","func":"' + 'seekTo' + '","args":[0,true]}', '*');
    }

    let focusItems = [...target.querySelectorAll('[tabindex]')];
    focusItems.forEach(el => {
      el.setAttribute('tabindex', -1);
    });

    trigger.focus();
    bodyStatic();
  }

  ariaSet() {
    this.modalTrigger.forEach(el => {
      el.setAttribute('aria-expanded', 'false');
      let ariaControls = el.getAttribute('aria-controls');
      const target = document.querySelector('.js-modal_target[id="' + ariaControls + '"]');
      if(target) {
        target.setAttribute('aria-hidden', 'true');
      }
    });
  }

  focusTrap() {
    this.modalTarget.forEach(el => {
      const focusableElements = el.querySelectorAll(this.focusableElementsString);
      const firstFocusableElement = focusableElements[0];
      const lastFocusableElement = focusableElements[focusableElements.length - 1];

      focusableElements.forEach(e => {
        e.setAttribute('tabindex', -1);
      });

      el.addEventListener('keydown', (e) => {
        if(e.key === 'Tab') {
          if(e.shiftKey) {
            if(document.activeElement === firstFocusableElement) {
              e.preventDefault();
              lastFocusableElement.focus();
            }
          } else {
            if(document.activeElement === lastFocusableElement) {
              e.preventDefault();
              firstFocusableElement.focus();
            }
          }
        } else if(e.key === 'Escape') {
          this.closeCnt();
        }
      });
    });
  }
}